import React from "react";

export default function Image({ src, srcSet = [], ...others }) {
  return (
    <img
      src={src || srcSet[0].split(" ")[0]}
      srcSet={srcSet.join(",")}
      lazy="true"
      {...others}
    />
  );
}
